// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linesContainer_d_s4I {
  height: 60% !important;
  width: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;
  margin-top: 100px;
  background-color: #2c2c2c;
  border-radius: 40px;
  -webkit-border-radius: 40px;
  -moz-border-radius: 40px;
  -ms-border-radius: 40px;
  -o-border-radius: 40px;
  padding: 40px 20px;
  box-sizing: border-box;
  gap: 40px;
  min-height: 50vh;

  h3 {
    color: var(--white-background);
    font-size: clamp(20px, 5vw, 40px);
    width: 80%;

    text-align: center;
    font-weight: 400;
    margin: 0;
  }

  p {
    color: var(--white-background);
    font-size: 20px;
    text-align: center;
    margin: 0;
  }
}
@media (width<= 1024px) {
  .linesContainer_d_s4I {
    height: 100% !important;
    h3 {
      width: 100%;
    }
  }
}
.imgContainerLines_YAI1B > svg {
  object-fit: contain;
  width: 100%;
  height: 100%;
}



.logo_fOuBz {
  position: absolute;
  z-index: 3;
}





@media (width <=950px) {
  .logo_fOuBz {
    width: 50px;
    height: 50px;
  }

}

@media (width <= 570px) {

  .logo_fOuBz {
    width: 40px;
    height: 40px;
  }


}

@media (width <=400px) {
  .logo_fOuBz {
    width: 30px;
  }
 
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/LinesLandingSection/LinesLandingSection.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;;EAEhB;IACE,8BAA8B;IAC9B,iCAAiC;IACjC,UAAU;;IAEV,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;AACF;AACA;EACE;IACE,uBAAuB;IACvB;MACE,WAAW;IACb;EACF;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,UAAU;AACZ;;;;;;AAMA;EACE;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;AAEA;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;;AAGF;;AAEA;EACE;IACE,WAAW;EACb;;AAEF","sourcesContent":[".linesContainer {\n  height: 60% !important;\n  width: 95%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  flex-direction: column;\n  margin-top: 100px;\n  background-color: #2c2c2c;\n  border-radius: 40px;\n  -webkit-border-radius: 40px;\n  -moz-border-radius: 40px;\n  -ms-border-radius: 40px;\n  -o-border-radius: 40px;\n  padding: 40px 20px;\n  box-sizing: border-box;\n  gap: 40px;\n  min-height: 50vh;\n\n  h3 {\n    color: var(--white-background);\n    font-size: clamp(20px, 5vw, 40px);\n    width: 80%;\n\n    text-align: center;\n    font-weight: 400;\n    margin: 0;\n  }\n\n  p {\n    color: var(--white-background);\n    font-size: 20px;\n    text-align: center;\n    margin: 0;\n  }\n}\n@media (width<= 1024px) {\n  .linesContainer {\n    height: 100% !important;\n    h3 {\n      width: 100%;\n    }\n  }\n}\n.imgContainerLines > svg {\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n}\n\n\n\n.logo {\n  position: absolute;\n  z-index: 3;\n}\n\n\n\n\n\n@media (width <=950px) {\n  .logo {\n    width: 50px;\n    height: 50px;\n  }\n\n}\n\n@media (width <= 570px) {\n\n  .logo {\n    width: 40px;\n    height: 40px;\n  }\n\n\n}\n\n@media (width <=400px) {\n  .logo {\n    width: 30px;\n  }\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linesContainer": `linesContainer_d_s4I`,
	"imgContainerLines": `imgContainerLines_YAI1B`,
	"logo": `logo_fOuBz`
};
export default ___CSS_LOADER_EXPORT___;
